import { type ImportantModalProps } from "@/features/brain/legacy/components/ImportantModal/type"

type item = Pick<
  ImportantModalProps,
  | "timeout"
  | "icon"
  | "illustration"
  | "title"
  | "subtitle"
  | "description"
  | "subDescription"
  | "textPrimary"
  | "textSecondary"
>

type items = Record<string, item>

export const MODAL_TUTO_STEP = {
  0: "tutRenforcement1",
  1: "tutRenforcement2",
  2: "tutRenforcement3",
  3: "tutRenforcement4",
}

export const IMPORTANT_MODALS: items = {
  tutRenforcement1: {
    icon: "fa-thin fa-lightbulb",
    illustration: "/img/brain/new/sample1.png",
    title: "brain.tutorial.start.tutorial_1.success.title",
    description: "brain.tutorial.start.tutorial_1.success.body",
    textPrimary: "general.next",
    textSecondary: "general.try_again",
  },
  tutRenforcement2: {
    icon: "fa-thin fa-bolt",
    illustration: "/img/brain/new/sample2.png",
    title: "brain.tutorial.start.tutorial_2.success.title",
    description: "brain.tutorial.start.tutorial_2.success.body_1",
    subDescription: "brain.tutorial.start.tutorial_2.success.body_2",
    textPrimary: "general.next",
    textSecondary: "general.try_again",
  },
  tutRenforcement3: {
    icon: "fa-thin fa-face-smile",
    illustration: "/img/brain/new/sample3.png",
    title: "brain.tutorial.start.tutorial_3.success.title",
    description: "brain.tutorial.start.tutorial_3.success.body",
    textPrimary: "general.next",
    textSecondary: "general.try_again",
  },
  tutRenforcement4: {
    icon: "fa-thin fa-trophy-star",
    illustration: "/img/brain/new/sample4.png",
    title: "brain.tutorial.start.tutorial_4.success.title",
    description: "brain.tutorial.start.tutorial_4.success.body",
    textPrimary: "general.next",
    textSecondary: "general.try_again",
  },
  incompleteAnswer: {
    icon: "fa-thin fa-circle-exclamation",
    subtitle: "brain.assessment.pass.title",
    description: "brain.assessment.pass.body",
    textPrimary: "brain.assessment.pass.cta_1",
    textSecondary: "brain.assessment.pass.cta_2",
  },
  idleOne: {
    icon: "fa-thin fa-face-smile",
    subtitle: "brain.assessment.idle.title",
    description: "brain.assessment.idle.body",
    textPrimary: "general.ok",
  },
  idleTwo: {
    icon: "fa-thin fa-face-smile",
    subtitle: "shape.assessment.idle.title",
    description: "shape.assessment.idle.body",
    textPrimary: "general.reload",
  },
  idleThree: {
    timeout: 3000,
    icon: "fa-thin fa-face-smile",
    subtitle: "brainlegacy.time_up_2",
  },
  mileStoneOne: {
    timeout: 7000,
    icon: "fa-thin fa-face-smile",
    title: "brain.assessment.milestone.one.title",
    description: "brain.assessment.milestone.one.body",
  },
  mileStoneTwo: {
    timeout: 7000,
    icon: "fa-thin fa-face-smile",
    title: "brain.assessment.milestone.two.title",
    description: "brain.assessment.milestone.two.body",
  },
  mileStoneThree: {
    timeout: 7000,
    icon: "fa-thin fa-face-smile",
    title: "brain.assessment.milestone.three.title",
    description: "brain.assessment.milestone.three.body",
  },
}
